import { useMutation } from '@tanstack/react-query'
import { unsubscribeFromProject } from 'api'
import { paths } from 'app/routes'
import { IconUnsubscribe } from 'assets/icons'
import { SettingsItem } from 'components/global'
import { Dialog, DialogContent, ToastContent } from 'elements/feedback'
import { Button } from 'elements/inputs/button'
import { useBoolean } from 'lib/hooks'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

type UnsubscribeBlockProps = { projectId: string; projectName: string }

export const UnsubscribeBlock = ({
  projectId,
  projectName,
}: UnsubscribeBlockProps) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const isOpen = useBoolean()

  const $unsubscribeFromProject = useMutation(unsubscribeFromProject)

  return (
    <>
      <SettingsItem
        title={t('projects.settings.unsubscribe')}
        customButton={
          <Button
            variant="text"
            sx={{
              color: 'error.main',
              p: 0,
              height: 'auto',

              '&:hover': { background: 'none' },
            }}
            startIcon={<IconUnsubscribe />}
            onClick={isOpen.setTrue}
          >
            {t('projects.settings.leave_the_project')}
          </Button>
        }
      />

      <Dialog open={isOpen.isTrue} onClose={isOpen.setFalse} size="small">
        <DialogContent
          title={t('projects.settings.unsubscription_confirmation', {
            projectName,
          })}
          isActionLoading={$unsubscribeFromProject.isLoading}
          onConfirm={() => {
            $unsubscribeFromProject.mutate(
              { projectId },
              {
                onSuccess: () => {
                  navigate(paths.projects)
                  toast.success(
                    <ToastContent
                      title={t('projects.settings.successfully_unsubscribed', {
                        projectName,
                      })}
                    />,
                  )
                },
              },
            )
          }}
          onDeny={isOpen.setFalse}
          confirmText={t('projects.settings.unsubscribe')}
          denyText={t('common.cancel')}
        />
      </Dialog>
    </>
  )
}
